import { useEffect, useRef } from 'react';
import styles from './CheckBox.module.scss';

type CheckBoxProps = {
    label: string;
    checked: boolean;
    onCheck: (checked: boolean) => void;
    variant: 'primary' | 'secondary' | 'tertiary';
    needPadding?: boolean;
    style?: React.CSSProperties;
    labelStyles?: React.CSSProperties;
    disabled?: boolean;
    indeterminate?: boolean;
};

const CheckBox = (props: CheckBoxProps) => {
    const { label, checked, onCheck, variant, needPadding, labelStyles } = props;
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) inputRef.current.indeterminate = !!props.indeterminate;
    }, [props.indeterminate]);

    return (
        <div className={`${styles.CheckBox} ${needPadding ? styles.NeedPadding : ''}`} style={props.style}>
            <input
                ref={inputRef}
                type="checkbox"
                id={label}
                disabled={props.disabled}
                checked={checked}
                onChange={(e) => onCheck(e.target.checked)}
            />
            <label htmlFor={label} style={labelStyles} className={styles[variant]}>
                {label}
            </label>
        </div>
    );
};

export default CheckBox;
